import React from 'react';

import Login from './Pages/Login/Login'
import ResetPassword from './Pages/Login/ResetPassword'
import SignUp from './Pages/Login/SignUp'
import ConfirmEmail from './Pages/Login/ConfirmEmail'
import ForgotPassword from './Pages/Login/ForgotPassword'
import ForgotPasswordConfirm from './Pages/Login/ForgotPasswordConfirm'
import MFALogin from './Pages/Login/MFALogin'

import NotFound from './Routes/NotFound'

import Monotributo from './Pages/AdminPanel/Monotributo'
import Plans from './Pages/AdminPanel/Plans'
//import Parameters from './Pages/AdminPanel/Parameters'
import UploadInvoices from './Pages/AdminPanel/UploadInvoices'
import EditUser from './Pages/AdminPanel/EditUser'
import NewUser from './Pages/AdminPanel/NewUser'

import Dashboard from './Pages/UserPanel/Dashboard'
import DashboardAdmin from './Pages/AdminPanel/DashboardAdmin'
import DashboardAdminLite from './Pages/AdminLite/DashboardAdminLite'
//import SetupMFA from './Pages/UserPanel/SetupMFA'
import Invoice from './Pages/UserPanel/Invoice'
import EmittedInvoices from './Pages/UserPanel/EmittedInvoices'
import StepsUser from './Pages/UserPanel/StepsUser'
import UpgradePlan from './Pages/UserPanel/UpgradePlan'
import Taxes from './Pages/UserPanel/Taxes'
//import Certificate from './Pages/UserPanel/Certificate'
import CheckInvoices from './Pages/Services/CheckInvoices'
import CheckInvoicesCSV from './Pages/Services/CheckInvoicesCSV'
import InvoiceVisualizer from './Pages/UserPanel/InvoiceVisualizer'
import Iibb from './Pages/AdminPanel/Iibb'
import MiCuenta from './Pages/UserPanel/MiCuenta'
import PagoServicios from './Pages/UserPanel/PagoServicios'
import MercadoPago from './Components/Payments/MercadoPago'
import MercadoPagoMP from './Components/Payments/MercadoPagoMP'
import changePayment from './Pages/UserPanel/changePayment'
import InitialPlan from './Pages/UserPanel/InitialPlan'
import InitialPlanMP from './Pages/UserPanel/InitialPlanMP'
import MercadoPagoPayment from './Pages/UserPanel/MercadoPagoPayment'
import PostCheckoutSuccess  from './Pages/UserPanel/PostCheckoutSuccess'
import PostCheckoutError from './Pages/UserPanel/PostCheckoutError'
import PostCheckoutPending from './Pages/UserPanel/PostCheckoutPending'

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import { AdminRoute } from "./Routes/Admin"
import { AdminLiteRoute } from "./Routes/AdminLite"
import { AdminDCRoute } from "./Routes/AdminDC.js"
import { PrivateRoute } from "./Routes/Private";
import LoadUsersBatch from "./Pages/AdminLite/LoadUsersBatch";
import LoadInvoicesBatch from "./Pages/AdminLite/LoadInvoicesBatch";
import PersonalData from "./Pages/AdminLite/PersonalData";
import MiCuentaAdminLite from "./Pages/AdminLite/MiCuentaAdminLite";
import AdminLiteAdministration from "./Pages/AdminPanel/AdminLiteAdministration";
import EditUserLite from "./Pages/AdminPanel/EditUserLite";
import DashboardUserLite from "./Pages/UserLite/DashboardUserLite";
import {UserLiteRoute} from "./Routes/UserLite";

import DashboardDocumentControl from './Pages/DocumentControl/DashboardDocumentControl';
import UploadDocument from './Pages/DocumentControl/UploadDocument';
import Candidates from './Pages/DocumentControl/Candidates';
import Documents from './Pages/DocumentControl/Documents';
import DocumentTypes from './Pages/DocumentControl/DocumentTypes';
 
function App() {
  return (
    <Router>
      <Switch>

          {/* Login Pages */}
          <Route path='/login' component={Login} />
          <Route path='/login-mp' exact component={Login} />
          <Route path='/login-dc' exact component={Login} />
          <Route path='/password-reset' component={ResetPassword} />
          <Route path='/sign-up' component={SignUp} />
          <Route path='/sign-up-mp' exact component={SignUp} />
          <Route path='/confirm-email' component={ConfirmEmail} />
          <Route path='/mp-confirm-email' component={ConfirmEmail} />
          <Route path='/forgot-password' component={ForgotPassword} />
          <Route path='/forgot-password-confirm' component={ForgotPasswordConfirm} />
          <Route path='/mfa-login' component={MFALogin} />

          {/* User Pages */}
          <PrivateRoute path='/home' exact component={Dashboard} />
          <PrivateRoute path='/' exact component={Dashboard} />
          <PrivateRoute path='/mp' exact component={Dashboard} />
          <PrivateRoute path='/facturar' component={Invoice} />
          <PrivateRoute path='/facturas-emitidas' component={EmittedInvoices} />
          <PrivateRoute path='/steps-user/:id' component={StepsUser} userLite={true} />
          <PrivateRoute path='/steps-user-mp/:id' component={StepsUser} userLite={true} />
          <PrivateRoute path='/mejorar-plan' component={UpgradePlan} />
          <PrivateRoute path='/impuestos' component={Taxes} />
          {/*<PrivateRoute path='/emitir-constancia' component={Certificate} />*/}
          <PrivateRoute path='/visualizar-factura/:id' component={InvoiceVisualizer} userLite={true} />
          <PrivateRoute path='/micuenta' component={MiCuenta}/>
          <PrivateRoute path='/micuenta-lite' component={MiCuenta} userLite={true}/>
          <PrivateRoute path='/pago-servicios' component={PagoServicios}/>
          <PrivateRoute path ='/mercado-pago' component={MercadoPago}/>
          <PrivateRoute path ='/mercado-pago-mp/:id' component={MercadoPagoMP}/>
          <PrivateRoute path ='/medio-pago/:id' component ={changePayment}/>
          <PrivateRoute path ='/medio-pago-mp/:id' component ={MercadoPagoPayment}/>
          <PrivateRoute path ='/initial-plan/:id' component ={InitialPlan}/>
          <PrivateRoute path ='/initial-plan-mp/:id' component ={InitialPlanMP}/>
          <PrivateRoute path = '/checkout/success' component={PostCheckoutSuccess}/>
          <PrivateRoute path = '/checkout/error' component={PostCheckoutError}/>
          <PrivateRoute path = '/checkout/pending' component={PostCheckoutPending}/>

          {/* Admin Pages */}
          <AdminRoute path='/admin' exact component={DashboardAdmin} />
          <AdminRoute path='/monotributo' exact component={Monotributo} />
          <AdminRoute path='/planes' exact component={Plans} />
          {/*<AdminRoute path='/parametros' exact component={Parameters} />*/}
          <AdminRoute path='/facturador' exact component={UploadInvoices} />
          <AdminRoute path='/verificar-factura' exact component={CheckInvoices} />
          <AdminRoute path='/verificar-facturas' exact component={CheckInvoicesCSV} />
          <AdminRoute path='/edit-user/:id' component={EditUser} />
          <AdminRoute path='/edit-user-admin-lite/:id' component={EditUserLite} />
          <AdminRoute path='/new-user' component={NewUser} />
          <AdminRoute path='/iibb' exact component ={Iibb}/>
          <AdminRoute path='/admin-lites' exact component ={AdminLiteAdministration}/>
          {/* Admin-Lite Pages */}
          <AdminLiteRoute path='/admin-lite' exact component ={DashboardAdminLite}/>
          <AdminLiteRoute path='/load-users-batch' exact component ={LoadUsersBatch}/>
          <AdminLiteRoute path='/load-invoices-batch' exact component ={LoadInvoicesBatch}/>
          <AdminLiteRoute path='/personal-data' component={PersonalData} />
          <AdminLiteRoute path='/micuenta-adminlite' component={MiCuentaAdminLite}/>

          {/* Document-Control Pages */}
          <AdminDCRoute path='/document-control' exact component ={DashboardDocumentControl}/>
          <AdminDCRoute path='/upload-document' exact component ={UploadDocument}/>
          <AdminDCRoute path='/candidates' exact component ={Candidates}/>
          <AdminDCRoute path='/documents' exact component ={Documents}/>
          <AdminDCRoute path="/document-types" exact component ={DocumentTypes}/>

          {/* User-Lite Pages */}
          <UserLiteRoute path='/user-lite' exact component ={DashboardAdminLite}/>

          <PrivateRoute component={NotFound} userLite={true} />

      </Switch>
    </Router>
  );
}

export default App;
